// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3edc2bee","703":"673f6e86","787":"25471cf6"}[chunkId] + ".chunk.js";
};